import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import PageContainer from '../../Components/PageContainer'
import { auth } from '../../firebase'

export default function PRO() {
    const navigate = useNavigate()
    useEffect(() => {
        if (!auth.currentUser) {
            return window.location.replace("/login")
        }
    }, [])
    const Feature = ({ children }) => {
        return (
            <div className="flex aic" style={{ gap: 10, overflow: "visible" }}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#0074D9"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
                <p style={{ fontWeight: 600, opacity: .8 }}>{children}</p>
            </div>
        )
    }
    const FeatureContainer = ({ list, nb }) => {
        return (
            <div className="flex fdc featureContainer" style={{ gap: 10, borderRight: nb ? "none" : "2px solid rgba(0,0,0,.1)", padding: "0 10px", flex: 1 }} >
                {list.map((feature, idx) => {
                    return (
                        <Feature key={idx}>{feature}</Feature>
                    )
                })}
            </div>
        )
    }
    return (
        <PageContainer>
            <div style={{ padding: "30px" }} className="pgePadd">
                <div className="flex aic jcc fdc" style={{ marginTop: 40 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="60px" viewBox="0 0 24 24" width="60px" fill="#000000"><g><rect fill="none" height="24" width="24" /></g><g><g><path d="M23,11.99l-2.44-2.79l0.34-3.69l-3.61-0.82L15.4,1.5L12,2.96L8.6,1.5L6.71,4.69L3.1,5.5L3.44,9.2L1,11.99l2.44,2.79 l-0.34,3.7l3.61,0.82L8.6,22.5l3.4-1.47l3.4,1.46l1.89-3.19l3.61-0.82l-0.34-3.69L23,11.99z M19.05,13.47l-0.56,0.65l0.08,0.85 l0.18,1.95l-1.9,0.43l-0.84,0.19l-0.44,0.74l-0.99,1.68l-1.78-0.77L12,18.85l-0.79,0.34l-1.78,0.77l-0.99-1.67l-0.44-0.74 l-0.84-0.19l-1.9-0.43l0.18-1.96l0.08-0.85l-0.56-0.65l-1.29-1.47l1.29-1.48l0.56-0.65L5.43,9.01L5.25,7.07l1.9-0.43l0.84-0.19 l0.44-0.74l0.99-1.68l1.78,0.77L12,5.14l0.79-0.34l1.78-0.77l0.99,1.68l0.44,0.74l0.84,0.19l1.9,0.43l-0.18,1.95l-0.08,0.85 l0.56,0.65l1.29,1.47L19.05,13.47z" /><polygon points="10.09,13.75 7.77,11.42 6.29,12.91 10.09,16.72 17.43,9.36 15.95,7.87" /></g></g></svg>
                    <h1 style={{ textAlign: "center" }}>Upgrade to <span style={{ color: "#0074D9" }}>PRO</span> for only £7.99/month</h1>
                    <p style={{ marginTop: 0, fontWeight: "bold", opacity: .6, textAlign: "center" }}>Get access to exclusive features only available to PRO users</p>
                </div>
                <div style={{ width: "100%", padding: 30, background: "white", borderRadius: 10, marginTop: 30, gap: 30, flexWrap: "wrap" }} className="bb flex featureContainersContainer">
                    <FeatureContainer list={["No poll expiry date", "Unlimited options", "Poll analytics"]} />
                    <FeatureContainer list={["Post poll CTA", "Unlimited voters", "PRO account status"]} />
                    <FeatureContainer nb list={["Limit voter count"]} />
                </div>
                <div className="flex aic jcc" style={{ marginTop: 40 }}>
                    <button onClick={() => navigate("/pro/checkout")} className="b3 flex aic jcc" style={{ textAlign: "center", gap: 10 }}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"><path d="M0 0h24v24H0z" fill="none" /><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" /></svg>                    Go to checkout
                    </button>
                </div>
            </div>
        </PageContainer>
    )
}
